"use client";

import { useSetAtom } from "jotai";
import { useCallback, useEffect, useRef } from "react";
import { PannelVisible, ShowItemIndex } from "./Pannel";
import { cn } from "@/lib/utils";

export default function Nav(props: {
  children: React.ReactNode;
  className?: string;
}) {
  const navRef = useRef<HTMLDivElement>(null);

  const setShow = useSetAtom(PannelVisible);

  const setShowIndex = useSetAtom(ShowItemIndex);

  useEffect(() => {
    if (!navRef.current) return;

    const nav = navRef.current;

    nav.addEventListener("mouseleave", () => {
      setShow(false);
      setShowIndex(null);
    });
  }, [setShow, setShowIndex]);

  return (
    <nav
      ref={navRef}
      className={cn(
        "relative hidden h-full w-full transition-all duration-300 md:block",
        props.className
      )}
      id="app-nav">
      {props.children}
    </nav>
  );
}
